var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-page"},[_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"page-header header-filter",style:(_vm.bgImage),attrs:{"filter-color":"black"}},[_c('div',{staticClass:"container md-offset"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }